/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientDataChangedDto
 */
export interface ClientDataChangedDto {
    /**
     * 
     * @type {boolean}
     * @memberof ClientDataChangedDto
     */
    purchaserDataChanged?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDataChangedDto
     */
    recipientDataChanged?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDataChangedDto
     */
    isFormalCorrection?: boolean | null;
}

/**
 * Check if a given object implements the ClientDataChangedDto interface.
 */
export function instanceOfClientDataChangedDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientDataChangedDtoFromJSON(json: any): ClientDataChangedDto {
    return ClientDataChangedDtoFromJSONTyped(json, false);
}

export function ClientDataChangedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDataChangedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purchaserDataChanged': !exists(json, 'purchaserDataChanged') ? undefined : json['purchaserDataChanged'],
        'recipientDataChanged': !exists(json, 'recipientDataChanged') ? undefined : json['recipientDataChanged'],
        'isFormalCorrection': !exists(json, 'isFormalCorrection') ? undefined : json['isFormalCorrection'],
    };
}

export function ClientDataChangedDtoToJSON(value?: ClientDataChangedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purchaserDataChanged': value.purchaserDataChanged,
        'recipientDataChanged': value.recipientDataChanged,
        'isFormalCorrection': value.isFormalCorrection,
    };
}

